import { render } from "./MainSection.vue?vue&type=template&id=5f56dad2"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=5f56dad2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__